import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

export default function Profile() {
  const navigate = useNavigate();
  const settings = useSettings();
  const [user, setUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userStr = localStorage.getItem("user");
    
    if (!token || !userStr) {
      navigate("/login");
      return;
    }
    
    const userData = JSON.parse(userStr);
    setUser(userData);
    setFormData({
      name: userData.name || "",
      email: userData.email || "",
      phone: userData.phone || "",
      address: userData.address || "",
    });
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });
    
    // Simulate API call - in real app, update to backend
    setTimeout(() => {
      const updatedUser = { ...user, ...formData };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      setUser(updatedUser);
      setIsEditing(false);
      setMessage({ type: "success", text: "Profil berhasil diperbarui!" });
      setLoading(false);
    }, 1000);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  if (!user) return null;

  const pageTitle = `Profil Saya - ${settings.site_name || "HandyCraft Bali"}`;

  return (
    <div className="container" style={{ paddingTop: "40px", paddingBottom: "80px" }}>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Kelola profil dan informasi akun Anda di HandyCraft Bali." />
      </Helmet>

      <div className="section-header" style={{ textAlign: "left", marginBottom: "30px" }}>
        <p>Profil Pengguna</p>
        <h2 className="section-title">Informasi Akun Saya</h2>
      </div>

      {message.text && (
        <div
          style={{
            padding: "15px 20px",
            borderRadius: "12px",
            marginBottom: "20px",
            background: message.type === "success" ? "#E8F5E9" : "#FFEBEE",
            color: message.type === "success" ? "#2E7D32" : "#C62828",
            fontWeight: 500,
          }}
        >
          {message.text}
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "30px",
        }}
      >
        {/* Profile Card */}
        <div
          style={{
            background: "white",
            borderRadius: "24px",
            padding: "40px",
            border: "1px solid var(--border)",
            boxShadow: "var(--shadow)",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                background: "var(--primary-gradient)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "3rem",
                margin: "0 auto 20px",
                color: "white",
              }}
            >
              {user.name?.charAt(0).toUpperCase() || "👤"}
            </div>
            <h3 style={{ color: "var(--secondary)", marginBottom: "5px" }}>{user.name}</h3>
            <p style={{ color: "#888", fontSize: "0.9rem" }}>{user.email}</p>
            <span
              style={{
                display: "inline-block",
                marginTop: "10px",
                padding: "4px 12px",
                background: user.role === "admin" ? "#FFF3E0" : "#E3F2FD",
                color: user.role === "admin" ? "#E65100" : "#1565C0",
                borderRadius: "20px",
                fontSize: "0.75rem",
                fontWeight: 600,
                textTransform: "uppercase",
              }}
            >
              {user.role === "admin" ? "Administrator" : "Member"}
            </span>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Link
              to="/orders"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                padding: "15px",
                background: "var(--bg)",
                borderRadius: "12px",
                color: "var(--secondary)",
                fontWeight: 600,
                textDecoration: "none",
                transition: "all 0.2s",
              }}
            >
              <span>📦</span> Riwayat Pesanan
            </Link>
            
            {user.role === "admin" && (
              <Link
                to="/admin/dashboard"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "15px",
                  background: "var(--secondary)",
                  borderRadius: "12px",
                  color: "white",
                  fontWeight: 600,
                  textDecoration: "none",
                  transition: "all 0.2s",
                }}
              >
                <span>⚙️</span> Panel Admin
              </Link>
            )}

            <button
              onClick={handleLogout}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                padding: "15px",
                background: "#FFF5F5",
                borderRadius: "12px",
                color: "#C53030",
                fontWeight: 600,
                border: "none",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              <span>🚪</span> Keluar
            </button>
          </div>
        </div>

        {/* Edit Profile Form */}
        <div
          style={{
            background: "white",
            borderRadius: "24px",
            padding: "40px",
            border: "1px solid var(--border)",
            boxShadow: "var(--shadow)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "25px" }}>
            <h4 style={{ color: "var(--secondary)", margin: 0 }}>Edit Profil</h4>
            <button
              onClick={() => setIsEditing(!isEditing)}
              style={{
                padding: "8px 16px",
                background: isEditing ? "#FFEBEE" : "var(--bg)",
                borderRadius: "8px",
                border: "none",
                color: isEditing ? "#C62828" : "var(--secondary)",
                fontWeight: 600,
                cursor: "pointer",
                fontSize: "0.85rem",
              }}
            >
              {isEditing ? "Batal" : "✏️ Edit"}
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: "var(--text)",
                }}
              >
                Nama Lengkap
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                disabled={!isEditing}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid var(--border)",
                  fontSize: "1rem",
                  background: isEditing ? "white" : "var(--bg)",
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: "var(--text)",
                }}
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled={!isEditing}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid var(--border)",
                  fontSize: "1rem",
                  background: isEditing ? "white" : "var(--bg)",
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: "var(--text)",
                }}
              >
                Nomor WhatsApp
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                disabled={!isEditing}
                placeholder="Contoh: 6281234567890"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid var(--border)",
                  fontSize: "1rem",
                  background: isEditing ? "white" : "var(--bg)",
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: "var(--text)",
                }}
              >
                Alamat Lengkap
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                disabled={!isEditing}
                rows={4}
                placeholder="Alamat pengiriman lengkap..."
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid var(--border)",
                  fontSize: "1rem",
                  background: isEditing ? "white" : "var(--bg)",
                  resize: "vertical",
                  fontFamily: "inherit",
                }}
              />
            </div>

            {isEditing && (
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary"
                style={{ width: "100%" }}
              >
                {loading ? "Menyimpan..." : "💾 Simpan Perubahan"}
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
